export enum EventType {
  CourtDate = "courtDate",
  Appointment = "orderedAppointment",
}

export enum S3UploadType {
  PNG = "image/png",
  PNG_MIME_TYPE = "application/png",
}
